import dataSelect from '@store/dataForSelect/reducers';

import { area_of_interest_select } from '../../configs/constants';

export default dataSelect(area_of_interest_select);
